import React from 'react';
import { motion } from 'framer-motion';
import { Facebook, Instagram } from 'lucide-react';
import { useLanguage } from '../context/LanguageContext';
import { socialLinks } from '../mock';

const Footer = () => {
  const { t } = useLanguage();

  return (
    <footer className="relative bg-[#2A2520] py-12 border-t border-[#F5F1E8]/10">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid md:grid-cols-3 gap-8 mb-8">
          {/* Brand */}
          <div>
            <h3 className="text-2xl font-serif text-[#F5F1E8] mb-3">
              Ca' del Sole Italia
            </h3>
            <p className="text-[#F5F1E8]/60 text-sm italic">{t.footer.tagline}</p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-[#D4AF37] mb-3 tracking-wider uppercase text-sm">
              Link Rapidi
            </h4>
            <div className="space-y-2">
              {[
                { label: t.nav.casa, id: 'casa' },
                { label: t.nav.eventi, id: 'eventi' },
                { label: t.nav.galleria, id: 'galleria' },
                { label: t.nav.contatti, id: 'contatti' },
              ].map((item) => (
                <button
                  key={item.id}
                  onClick={() =>
                    document.getElementById(item.id)?.scrollIntoView({ behavior: 'smooth' })
                  }
                  className="block text-[#F5F1E8]/60 hover:text-[#D4AF37] transition-colors duration-300 text-sm"
                >
                  {item.label}
                </button>
              ))}
            </div>
          </div>

          {/* Social */}
          <div>
            <h4 className="text-[#D4AF37] mb-3 tracking-wider uppercase text-sm">
              {t.contact.social}
            </h4>
            <div className="flex gap-3">
              <motion.a
                href={socialLinks.facebook}
                target="_blank"
                rel="noopener noreferrer"
                whileHover={{ scale: 1.1, y: -3 }}
                className="w-10 h-10 rounded-full bg-[#F5F1E8]/10 flex items-center justify-center hover:bg-[#D4AF37]/20 transition-all duration-300"
              >
                <Facebook className="w-5 h-5 text-[#F5F1E8]" />
              </motion.a>
              <motion.a
                href={socialLinks.instagram}
                target="_blank"
                rel="noopener noreferrer"
                whileHover={{ scale: 1.1, y: -3 }}
                className="w-10 h-10 rounded-full bg-[#F5F1E8]/10 flex items-center justify-center hover:bg-[#D4AF37]/20 transition-all duration-300"
              >
                <Instagram className="w-5 h-5 text-[#F5F1E8]" />
              </motion.a>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="pt-8 border-t border-[#F5F1E8]/10 text-center">
          <p className="text-[#F5F1E8]/50 text-sm">{t.footer.rights}</p>
        </div>
      </div>

      {/* Decorative Top Line */}
      <div className="absolute top-0 left-0 w-full h-px bg-gradient-to-r from-transparent via-[#D4AF37] to-transparent" />
    </footer>
  );
};

export default Footer;
